{
  "boosters": {
    "free": {
      "name": "Booster Gratuit",
      "short": "Gratuit",
      "description": "Toutes les raretés, avec une chance très faible au-dessus d’Épique. Réserve qui se recharge en une heure."
    },
    "standard": {
      "name": "Booster Standard",
      "short": "Standard",
      "description": "Toutes les raretés, avec de meilleures chances de tomber sur du Peu-Commun et du Rare."
    },
    "premium": {
      "name": "Booster Premium",
      "short": "Premium",
      "description": "Toutes les raretés, avec une courbe centrée sur Rare et de bonnes chances d’Épique."
    },
    "legendary": {
      "name": "Booster Chanceux",
      "short": "Chanceux",
      "description": "Toutes les raretés, avec une courbe très favorable aux raretés élevées."
    }
  },
  "rarities": {
    "common": "Commun",
    "uncommon": "Peu-Commun",
    "rare": "Rare",
    "epic": "Épique",
    "legendary": "Légendaire",
    "mythic": "Mythique",
    "divine": "Divine",
    "senita": "Senita"
  },
  "roles": {
    "MAIN": "Principal",
    "SUPPORTING": "Secondaire",
    "BACKGROUND": "Figurant"
  },
  "categories": {
    "economy": "Économie",
    "collection": "Collection",
    "forge": "Forge",
    "boosters": "Boosters",
    "market": "Marché",
    "social": "Social",
    "dedication": "Assiduité"
  },
  "upgrades": {
    "1": "Carte de base",
    "2": "Surnom personnalisé",
    "3": "Couleur du nom",
    "4": "Bordure personnalisée",
    "5": "Emblème de carte",
    "6": "Halo coloré",
    "7": "Finition holographique",
    "8": "Signature personnelle",
    "9": "Aura animée",
    "10": "Portrait éveillé"
  },
  "quests": {
    "booster_opened": {
      "v0": {
        "title": "Ouvrir des boosters",
        "description_one": "Ouvre 1 booster, gratuit ou payant.",
        "description_other": "Ouvre {{count}} boosters, gratuits ou payants."
      },
      "v1": {
        "title": "Toutes pochettes",
        "description_one": "Ouvre 1 booster, quel que soit son type.",
        "description_other": "Ouvre {{count}} boosters, quel que soit leur type."
      },
      "v2": {
        "title": "Compteur d’ouvertures",
        "description_one": "Totalise 1 booster ouvert.",
        "description_other": "Totalise {{count}} boosters ouverts."
      },
      "title": "Ouvrir des boosters",
      "description_one": "Ouvre 1 booster, gratuit ou payant.",
      "description_other": "Ouvre {{count}} boosters, gratuits ou payants."
    },
    "character_new": {
      "v0": {
        "title": "Nouveaux personnages",
        "description_one": "Obtiens 1 personnage que tu ne possédais pas.",
        "description_other": "Obtiens {{count}} personnages que tu ne possédais pas."
      },
      "v1": {
        "title": "Nouvelles têtes",
        "description_one": "Ajoute 1 nouveau personnage à ton classeur.",
        "description_other": "Ajoute {{count}} nouveaux personnages à ton classeur."
      },
      "v2": {
        "title": "Cases vierges",
        "description_one": "Remplis 1 case vide de ta collection.",
        "description_other": "Remplis {{count}} cases vides de ta collection."
      },
      "title": "Nouveaux personnages",
      "description_one": "Obtiens 1 personnage que tu ne possédais pas.",
      "description_other": "Obtiens {{count}} personnages que tu ne possédais pas."
    },
    "character_duplicate": {
      "v0": {
        "title": "Doublons",
        "description_one": "Obtiens 1 personnage que tu possèdes déjà.",
        "description_other": "Obtiens {{count}} personnages que tu possèdes déjà."
      },
      "v1": {
        "title": "Déjà croisés",
        "description_one": "Retombe sur 1 personnage déjà possédé.",
        "description_other": "Retombe sur {{count}} personnages déjà possédés."
      },
      "v2": {
        "title": "Copies en trop",
        "description_one": "Accumule 1 doublon de carte.",
        "description_other": "Accumule {{count}} doublons de cartes."
      },
      "title": "Doublons",
      "description_one": "Obtiens 1 personnage que tu possèdes déjà.",
      "description_other": "Obtiens {{count}} personnages que tu possèdes déjà."
    },
    "auction_bid": {
      "v0": {
        "title": "Enchères",
        "description_one": "Crée une enchère ou fais 1 enchère.",
        "description_other": "Crée ou fais {{count}} enchères."
      },
      "v1": {
        "title": "Main sur le marteau",
        "description_one": "Lance ou relance 1 enchère.",
        "description_other": "Lance ou relance {{count}} enchères."
      },
      "v2": {
        "title": "Salle des ventes",
        "description_one": "Participe à 1 enchère.",
        "description_other": "Participe à {{count}} enchères."
      },
      "title": "Enchères",
      "description_one": "Crée une enchère ou fais 1 enchère.",
      "description_other": "Crée ou fais {{count}} enchères."
    },
    "collection_viewed": {
      "v0": {
        "title": "Consulter ta collection",
        "description_one": "Ouvre la page de ta collection 1 fois.",
        "description_other": "Ouvre la page de ta collection 1 fois."
      },
      "v1": {
        "title": "Tour du classeur",
        "description_one": "Feuillette ta collection 1 fois.",
        "description_other": "Feuillette ta collection 1 fois."
      },
      "v2": {
        "title": "Inventaire",
        "description_one": "Consulte tes cartes 1 fois.",
        "description_other": "Consulte tes cartes 1 fois."
      },
      "title": "Consulter ta collection",
      "description_one": "Ouvre la page de ta collection 1 fois.",
      "description_other": "Ouvre la page de ta collection 1 fois.",
      "description": "Ouvre la page de ta collection 1 fois."
    },
    "free_booster_opened": {
      "v0": {
        "title": "Booster gratuit",
        "description_one": "Ouvre 1 booster gratuit.",
        "description_other": "Ouvre {{count}} boosters gratuits."
      },
      "v1": {
        "title": "Réserve du jour",
        "description_one": "Dépense 1 charge de ta réserve gratuite.",
        "description_other": "Dépense {{count}} charges de ta réserve gratuite."
      },
      "v2": {
        "title": "Pochettes offertes",
        "description_one": "Ouvre 1 pochette gratuite.",
        "description_other": "Ouvre {{count}} pochettes gratuites."
      },
      "title": "Booster gratuit",
      "description_one": "Ouvre 1 booster gratuit.",
      "description_other": "Ouvre {{count}} boosters gratuits."
    },
    "premium_booster_opened": {
      "v0": {
        "title": "Booster Premium",
        "description_one": "Ouvre 1 booster Premium.",
        "description_other": "Ouvre {{count}} boosters Premium."
      },
      "v1": {
        "title": "Pochettes dorées",
        "description_one": "Ouvre 1 pochette Premium.",
        "description_other": "Ouvre {{count}} pochettes Premium."
      },
      "v2": {
        "title": "Au-dessus du lot",
        "description_one": "Tente 1 ouverture Premium.",
        "description_other": "Tente {{count}} ouvertures Premium."
      },
      "title": "Booster Premium",
      "description_one": "Ouvre 1 booster Premium.",
      "description_other": "Ouvre {{count}} boosters Premium."
    },
    "legendary_booster_opened": {
      "v0": {
        "title": "Booster Chanceux",
        "description_one": "Ouvre 1 booster Chanceux.",
        "description_other": "Ouvre {{count}} boosters Chanceux."
      },
      "v1": {
        "title": "Pochettes rares",
        "description_one": "Ouvre 1 pochette Chanceux.",
        "description_other": "Ouvre {{count}} pochettes Chanceux."
      },
      "v2": {
        "title": "Coup de chance",
        "description_one": "Tente 1 ouverture Chanceux.",
        "description_other": "Tente {{count}} ouvertures Chanceux."
      },
      "title": "Booster Chanceux",
      "description_one": "Ouvre 1 booster Chanceux.",
      "description_other": "Ouvre {{count}} boosters Chanceux."
    },
    "rare_or_better_obtained": {
      "v0": {
        "title": "Rare ou mieux",
        "description_one": "Obtiens 1 personnage Rare ou de rareté supérieure.",
        "description_other": "Obtiens {{count}} personnages Rares ou de rareté supérieure."
      },
      "v1": {
        "title": "Éclats de couleur",
        "description_one": "Tire 1 carte Rare, Épique, Légendaire, Mythique ou Divine.",
        "description_other": "Tire {{count}} cartes Rares ou mieux."
      },
      "v2": {
        "title": "Au-dessus du commun",
        "description_one": "Décroche 1 rareté Rare ou plus.",
        "description_other": "Décroche {{count}} raretés Rare ou plus."
      },
      "title": "Rare ou mieux",
      "description_one": "Obtiens 1 personnage Rare ou de rareté supérieure.",
      "description_other": "Obtiens {{count}} personnages Rares ou de rareté supérieure."
    },
    "epic_or_better_obtained": {
      "v0": {
        "title": "Épique ou mieux",
        "description_one": "Obtiens 1 personnage Épique ou de rareté supérieure.",
        "description_other": "Obtiens {{count}} personnages Épique ou de rareté supérieure."
      },
      "v1": {
        "title": "Halo violet",
        "description_one": "Tire 1 carte Épique, Légendaire, Mythique ou Divine.",
        "description_other": "Tire {{count}} cartes Épique ou mieux."
      },
      "v2": {
        "title": "Grand cru",
        "description_one": "Décroche 1 rareté Épique ou plus.",
        "description_other": "Décroche {{count}} raretés Épique ou plus."
      },
      "title": "Épique ou mieux",
      "description_one": "Obtiens 1 personnage Épique ou de rareté supérieure.",
      "description_other": "Obtiens {{count}} personnages Épique ou de rareté supérieure."
    },
    "card_upgraded": {
      "v0": {
        "title": "Améliorer des cartes",
        "description_one": "Améliore une carte 1 fois.",
        "description_other": "Améliore des cartes {{count}} fois."
      },
      "v1": {
        "title": "Atelier",
        "description_one": "Monte 1 carte d’un niveau.",
        "description_other": "Monte des cartes de {{count}} niveaux au total."
      },
      "v2": {
        "title": "Montée en gamme",
        "description_one": "Dépense 1 amélioration de carte.",
        "description_other": "Dépense {{count}} améliorations de cartes."
      },
      "title": "Améliorer des cartes",
      "description_one": "Améliore une carte 1 fois.",
      "description_other": "Améliore des cartes {{count}} fois."
    },
    "fragments_spent": {
      "v0": {
        "title": "Fragments dépensés",
        "description_one": "Dépense 1 fragment en améliorations de cartes.",
        "description_other": "Dépense {{count}} fragments en améliorations de cartes."
      },
      "v1": {
        "title": "Fourneau",
        "description_one": "Brûle 1 fragment dans la forge.",
        "description_other": "Brûle {{count}} fragments dans la forge."
      },
      "v2": {
        "title": "Investissement",
        "description_one": "Investis 1 fragment dans une carte.",
        "description_other": "Investis {{count}} fragments dans tes cartes."
      },
      "title": "Fragments dépensés",
      "description_one": "Dépense 1 fragment en améliorations de cartes.",
      "description_other": "Dépense {{count}} fragments en améliorations de cartes."
    },
    "fragments_earned": {
      "v0": {
        "title": "Fragments gagnés",
        "description_one": "Gagne 1 fragment.",
        "description_other": "Gagne {{count}} fragments."
      },
      "v1": {
        "title": "Récolte d’éclats",
        "description_one": "Ramasse 1 fragment.",
        "description_other": "Ramasse {{count}} fragments."
      },
      "v2": {
        "title": "Butin cristallin",
        "description_one": "Accumule 1 fragment.",
        "description_other": "Accumule {{count}} fragments."
      },
      "title": "Fragments gagnés",
      "description_one": "Gagne 1 fragment.",
      "description_other": "Gagne {{count}} fragments."
    },
    "listing_created": {
      "v0": {
        "title": "Annonces publiées",
        "description_one": "Publie 1 annonce sur le marché.",
        "description_other": "Publie {{count}} annonces sur le marché."
      },
      "v1": {
        "title": "Cartes en vitrine",
        "description_one": "Mets 1 carte en vente.",
        "description_other": "Mets {{count}} cartes en vente."
      },
      "v2": {
        "title": "Prix affiché",
        "description_one": "Crée 1 annonce de vente.",
        "description_other": "Crée {{count}} annonces de vente."
      },
      "title": "Annonces publiées",
      "description_one": "Publie 1 annonce sur le marché.",
      "description_other": "Publie {{count}} annonces sur le marché."
    },
    "market_purchase": {
      "v0": {
        "title": "Achats au marché",
        "description_one": "Achète 1 carte sur le marché.",
        "description_other": "Achète {{count}} cartes sur le marché."
      },
      "v1": {
        "title": "Bonne affaire",
        "description_one": "Conclus 1 achat au marché.",
        "description_other": "Conclus {{count}} achats au marché."
      },
      "v2": {
        "title": "Panier",
        "description_one": "Acquiers 1 carte via le marché.",
        "description_other": "Acquiers {{count}} cartes via le marché."
      },
      "title": "Achats au marché",
      "description_one": "Achète 1 carte sur le marché.",
      "description_other": "Achète {{count}} cartes sur le marché."
    },
    "trade_proposed": {
      "v0": {
        "title": "Échanges proposés",
        "description_one": "Propose 1 échange.",
        "description_other": "Propose {{count}} échanges."
      },
      "v1": {
        "title": "Main tendue",
        "description_one": "Envoie 1 offre d’échange.",
        "description_other": "Envoie {{count}} offres d’échange."
      },
      "v2": {
        "title": "Table de négoce",
        "description_one": "Ouvre 1 négociation d’échange.",
        "description_other": "Ouvre {{count}} négociations d’échange."
      },
      "title": "Échanges proposés",
      "description_one": "Propose 1 échange.",
      "description_other": "Propose {{count}} échanges."
    },
    "trade_completed": {
      "v0": {
        "title": "Échanges conclus",
        "description_one": "Conclus 1 échange.",
        "description_other": "Conclus {{count}} échanges."
      },
      "v1": {
        "title": "Marché conclu",
        "description_one": "Scelle 1 échange accepté.",
        "description_other": "Scelle {{count}} échanges acceptés."
      },
      "v2": {
        "title": "Poignée finale",
        "description_one": "Termine 1 troc.",
        "description_other": "Termine {{count}} trocs."
      },
      "title": "Échanges conclus",
      "description_one": "Conclus 1 échange.",
      "description_other": "Conclus {{count}} échanges."
    },
    "system_sale": {
      "v0": {
        "title": "Reventes au système",
        "description_one": "Revends 1 carte au système.",
        "description_other": "Revends {{count}} cartes au système."
      },
      "v1": {
        "title": "Faire de la place",
        "description_one": "Laisse partir 1 carte au système.",
        "description_other": "Laisse partir {{count}} cartes au système."
      },
      "v2": {
        "title": "Reprise instantanée",
        "description_one": "Cède 1 carte au rachat du système.",
        "description_other": "Cède {{count}} cartes au rachat du système."
      },
      "title": "Reventes au système",
      "description_one": "Revends 1 carte au système.",
      "description_other": "Revends {{count}} cartes au système."
    },
    "anima_spent": {
      "v0": {
        "title": "Anima dépensée",
        "description_one": "Dépense 1 Anima.",
        "description_other": "Dépense {{count}} Anima."
      },
      "v1": {
        "title": "Bourse ouverte",
        "description_one": "Laisse filer 1 Anima.",
        "description_other": "Laisse filer {{count}} Anima."
      },
      "v2": {
        "title": "Mise en jeu",
        "description_one": "Engage 1 Anima.",
        "description_other": "Engage {{count}} Anima."
      },
      "title": "Anima dépensée",
      "description_one": "Dépense 1 Anima.",
      "description_other": "Dépense {{count}} Anima."
    },
    "message_sent": {
      "v0": {
        "title": "Messages envoyés",
        "description_one": "Envoie 1 message privé.",
        "description_other": "Envoie {{count}} messages privés."
      },
      "v1": {
        "title": "Prise de parole",
        "description_one": "Écris 1 message à un ami.",
        "description_other": "Écris {{count}} messages à tes amis."
      },
      "v2": {
        "title": "Fil de discussion",
        "description_one": "Poste 1 message.",
        "description_other": "Poste {{count}} messages."
      },
      "title": "Messages envoyés",
      "description_one": "Envoie 1 message privé.",
      "description_other": "Envoie {{count}} messages privés."
    },
    "card_shared": {
      "v0": {
        "title": "Cartes partagées",
        "description_one": "Partage 1 carte dans une discussion.",
        "description_other": "Partage {{count}} cartes dans des discussions."
      },
      "v1": {
        "title": "Montrer son jeu",
        "description_one": "Montre 1 carte dans un message.",
        "description_other": "Montre {{count}} cartes dans tes messages."
      },
      "v2": {
        "title": "Carte postale",
        "description_one": "Envoie 1 carte à un ami.",
        "description_other": "Envoie {{count}} cartes à tes amis."
      },
      "title": "Cartes partagées",
      "description_one": "Partage 1 carte dans une discussion.",
      "description_other": "Partage {{count}} cartes dans des discussions."
    },
    "reaction_given": {
      "v0": {
        "title": "Réactions",
        "description_one": "Réagis 1 fois à un message.",
        "description_other": "Réagis {{count}} fois à des messages."
      },
      "v1": {
        "title": "Petit signe",
        "description_one": "Laisse 1 réaction.",
        "description_other": "Laisse {{count}} réactions."
      },
      "v2": {
        "title": "Émoji",
        "description_one": "Ajoute 1 réaction à un message.",
        "description_other": "Ajoute {{count}} réactions à des messages."
      },
      "title": "Réactions",
      "description_one": "Réagis 1 fois à un message.",
      "description_other": "Réagis {{count}} fois à des messages."
    },
    "friend_request_sent": {
      "v0": {
        "title": "Demande d’ami",
        "description_one": "Envoie 1 demande d’ami.",
        "description_other": "Envoie 1 demande d’ami."
      },
      "v1": {
        "title": "Nouveau contact",
        "description_one": "Tends la main à 1 joueur.",
        "description_other": "Tends la main à 1 joueur."
      },
      "v2": {
        "title": "Invitation",
        "description_one": "Invite 1 joueur comme ami.",
        "description_other": "Invite 1 joueur comme ami."
      },
      "title": "Demande d’ami",
      "description_one": "Envoie 1 demande d’ami.",
      "description_other": "Envoie 1 demande d’ami."
    },
    "profile_viewed": {
      "v0": {
        "title": "Profils visités",
        "description_one": "Ouvre le profil d’un autre joueur.",
        "description_other": "Ouvre le profil d’un autre joueur."
      },
      "v1": {
        "title": "Curiosité",
        "description_one": "Va voir 1 profil de joueur.",
        "description_other": "Va voir 1 profil de joueur."
      },
      "v2": {
        "title": "Passage",
        "description_one": "Consulte 1 page de joueur.",
        "description_other": "Consulte 1 page de joueur."
      },
      "title": "Profils visités",
      "description_one": "Ouvre le profil d’un autre joueur.",
      "description_other": "Ouvre le profil d’un autre joueur."
    },
    "collection_compared": {
      "v0": {
        "title": "Comparer une collection",
        "description_one": "Compare ta collection à celle d’un autre joueur.",
        "description_other": "Compare ta collection à celle d’un autre joueur."
      },
      "v1": {
        "title": "Face à face",
        "description_one": "Mets ton classeur en regard d’un autre.",
        "description_other": "Mets ton classeur en regard d’un autre."
      },
      "v2": {
        "title": "Qui a quoi",
        "description_one": "Regarde ce qui te manque chez un joueur.",
        "description_other": "Regarde ce qui te manque chez un joueur."
      },
      "title": "Comparer une collection",
      "description_one": "Compare ta collection à celle d’un autre joueur.",
      "description_other": "Compare ta collection à celle d’un autre joueur."
    },
    "showcase_edited": {
      "v0": {
        "title": "Vitrine modifiée",
        "description_one": "Modifie ta vitrine 1 fois.",
        "description_other": "Modifie ta vitrine 1 fois."
      },
      "v1": {
        "title": "Nouvelle devanture",
        "description_one": "Réorganise tes cartes exposées.",
        "description_other": "Réorganise tes cartes exposées."
      },
      "v2": {
        "title": "Étagère",
        "description_one": "Retouche un emplacement de vitrine.",
        "description_other": "Retouche un emplacement de vitrine."
      },
      "title": "Vitrine modifiée",
      "description_one": "Modifie ta vitrine 1 fois.",
      "description_other": "Modifie ta vitrine 1 fois."
    },
    "favorite_added": {
      "v0": {
        "title": "Nouveaux favoris",
        "description_one": "Mets 1 personnage en favori.",
        "description_other": "Mets {{count}} personnages en favori."
      },
      "v1": {
        "title": "Étoile",
        "description_one": "Épingle 1 carte en favori.",
        "description_other": "Épingle {{count}} cartes en favori."
      },
      "v2": {
        "title": "Coup de cœur",
        "description_one": "Marque 1 personnage comme favori.",
        "description_other": "Marque {{count}} personnages comme favoris."
      },
      "title": "Nouveaux favoris",
      "description_one": "Mets 1 personnage en favori.",
      "description_other": "Mets {{count}} personnages en favori."
    },
    "cosmetic_equipped": {
      "v0": {
        "title": "Changer de style",
        "description_one": "Équipe 1 cosmétique.",
        "description_other": "Équipe 1 cosmétique."
      },
      "v1": {
        "title": "Nouvelle allure",
        "description_one": "Porte un titre, un badge, un cadre ou un filtre.",
        "description_other": "Porte un titre, un badge, un cadre ou un filtre."
      },
      "v2": {
        "title": "Essayage",
        "description_one": "Applique 1 cosmétique à ton profil.",
        "description_other": "Applique 1 cosmétique à ton profil."
      },
      "title": "Changer de style",
      "description_one": "Équipe 1 cosmétique.",
      "description_other": "Équipe 1 cosmétique."
    },
    "login_claimed": {
      "v0": {
        "title": "Connexion du jour",
        "description_one": "Réclame la récompense de connexion du calendrier.",
        "description_other": "Réclame la récompense de connexion du calendrier."
      },
      "v1": {
        "title": "Présent",
        "description_one": "Pointe au calendrier 1 fois.",
        "description_other": "Pointe au calendrier 1 fois."
      },
      "v2": {
        "title": "Rituel",
        "description_one": "Récupère le bonus quotidien du calendrier.",
        "description_other": "Récupère le bonus quotidien du calendrier."
      },
      "title": "Connexion du jour",
      "description_one": "Réclame la récompense de connexion du calendrier.",
      "description_other": "Réclame la récompense de connexion du calendrier."
    },
    "anime_completed": {
      "v0": {
        "title": "Animes complétés",
        "description_one": "Complète 1 anime.",
        "description_other": "Complète {{count}} animes."
      },
      "v1": {
        "title": "Série bouclée",
        "description_one": "Termine 1 série.",
        "description_other": "Termine {{count}} séries."
      },
      "v2": {
        "title": "Cent pour cent",
        "description_one": "Boucle 1 anime à 100 %.",
        "description_other": "Boucle {{count}} animes à 100 %."
      },
      "title": "Animes complétés",
      "description_one": "Complète 1 anime.",
      "description_other": "Complète {{count}} animes."
    },
    "achievement_unlocked": {
      "v0": {
        "title": "Succès débloqués",
        "description_one": "Débloque 1 succès.",
        "description_other": "Débloque {{count}} succès."
      },
      "v1": {
        "title": "Trophées",
        "description_one": "Décroche 1 trophée.",
        "description_other": "Décroche {{count}} trophées."
      },
      "v2": {
        "title": "Tableau d’honneur",
        "description_one": "Ajoute 1 succès à ton tableau.",
        "description_other": "Ajoute {{count}} succès à ton tableau."
      },
      "title": "Succès débloqués",
      "description_one": "Débloque 1 succès.",
      "description_other": "Débloque {{count}} succès."
    },
    "quest_claimed": {
      "v0": {
        "title": "Quêtes réclamées",
        "description_one": "Réclame 1 autre quête terminée.",
        "description_other": "Réclame {{count}} autres quêtes terminées."
      },
      "v1": {
        "title": "Récompense encaissée",
        "description_one": "Encaisse 1 quête terminée.",
        "description_other": "Encaisse {{count}} quêtes terminées."
      },
      "v2": {
        "title": "Tableau allégé",
        "description_one": "Valide 1 quête.",
        "description_other": "Valide {{count}} quêtes."
      },
      "title": "Quêtes réclamées",
      "description_one": "Réclame 1 autre quête terminée.",
      "description_other": "Réclame {{count}} autres quêtes terminées."
    }
  },
  "achievements": {
    "anima_balance": {
      "title": "Anima",
      "description_one": "Avoir {{formatted}} Anima.",
      "description_other": "Avoir {{formatted}} Anima."
    },
    "anima_spent": {
      "title": "Dépensier",
      "description_one": "Dépenser {{formatted}} Anima en boosters.",
      "description_other": "Dépenser {{formatted}} Anima en boosters."
    },
    "unique_characters": {
      "title": "Complétion",
      "description_one": "Posséder {{formatted}} personnage différent.",
      "description_other": "Posséder {{formatted}} personnages différents."
    },
    "owned_common": {
      "title": "Communs",
      "description_one": "Posséder {{formatted}} personnage Commun.",
      "description_other": "Posséder {{formatted}} personnages Communs."
    },
    "owned_uncommon": {
      "title": "Peu communs",
      "description_one": "Posséder {{formatted}} personnage Peu commun.",
      "description_other": "Posséder {{formatted}} personnages Peu communs."
    },
    "owned_rare": {
      "title": "Rares",
      "description_one": "Posséder {{formatted}} personnage Rare.",
      "description_other": "Posséder {{formatted}} personnages Rares."
    },
    "owned_epic": {
      "title": "Épiques",
      "description_one": "Posséder {{formatted}} personnage Épique.",
      "description_other": "Posséder {{formatted}} personnages Épiques."
    },
    "owned_legendary": {
      "title": "Légendaires",
      "description_one": "Posséder {{formatted}} personnage Légendaire.",
      "description_other": "Posséder {{formatted}} personnages Légendaires."
    },
    "owned_mythic": {
      "title": "Mythiques",
      "description_one": "Posséder {{formatted}} personnage Mythique.",
      "description_other": "Posséder {{formatted}} personnages Mythiques."
    },
    "owned_divine": {
      "title": "Divins",
      "description_one": "Posséder {{formatted}} personnage Divin.",
      "description_other": "Posséder {{formatted}} personnages Divins."
    },
    "owned_senita": {
      "title": "Senita",
      "description_one": "Posséder {{formatted}} personnage Senita.",
      "description_other": "Posséder {{formatted}} personnages Senita."
    },
    "animes_completed": {
      "title": "Séries complètes",
      "description_one": "Compléter {{formatted}} anime.",
      "description_other": "Compléter {{formatted}} animes."
    },
    "fragments_earned": {
      "title": "Fragments",
      "description_one": "Obtenir {{formatted}} fragment.",
      "description_other": "Obtenir {{formatted}} fragments."
    },
    "fragments_spent": {
      "title": "Fondeur",
      "description_one": "Dépenser {{formatted}} fragment.",
      "description_other": "Dépenser {{formatted}} fragments."
    },
    "upgrades": {
      "title": "Forgeron",
      "description_one": "Améliorer une carte {{formatted}} fois.",
      "description_other": "Améliorer des cartes {{formatted}} fois."
    },
    "boosters_opened": {
      "title": "Ouvreur",
      "description_one": "Ouvrir {{formatted}} booster.",
      "description_other": "Ouvrir {{formatted}} boosters."
    },
    "lucky_boosters_opened": {
      "title": "Chanceux",
      "description_one": "Ouvrir {{formatted}} Booster Chanceux.",
      "description_other": "Ouvrir {{formatted}} Boosters Chanceux."
    },
    "trades_completed": {
      "title": "Échangiste",
      "description_one": "Conclure {{formatted}} échange.",
      "description_other": "Conclure {{formatted}} échanges."
    },
    "listing_sales": {
      "title": "Vendeur",
      "description_one": "Vendre {{formatted}} carte sur le marché.",
      "description_other": "Vendre {{formatted}} cartes sur le marché."
    },
    "listing_purchases": {
      "title": "Acheteur",
      "description_one": "Acheter {{formatted}} carte sur le marché.",
      "description_other": "Acheter {{formatted}} cartes sur le marché."
    },
    "auctions_sold": {
      "title": "Commissaire-priseur",
      "description_one": "Vendre {{formatted}} carte aux enchères.",
      "description_other": "Vendre {{formatted}} cartes aux enchères."
    },
    "auctions_won": {
      "title": "Enchérisseur",
      "description_one": "Remporter {{formatted}} enchère.",
      "description_other": "Remporter {{formatted}} enchères."
    },
    "bids_placed": {
      "title": "Main levée",
      "description_one": "Placer {{formatted}} offre d’enchère.",
      "description_other": "Placer {{formatted}} offres d’enchère."
    },
    "friends_count": {
      "title": "Amis",
      "description_one": "Avoir {{formatted}} ami.",
      "description_other": "Avoir {{formatted}} amis."
    },
    "referrals_count": {
      "title": "Parrain",
      "description_one": "Parrainer {{formatted}} joueur vérifié.",
      "description_other": "Parrainer {{formatted}} joueurs vérifiés."
    },
    "messages_sent": {
      "title": "Bavard",
      "description_one": "Envoyer {{formatted}} message.",
      "description_other": "Envoyer {{formatted}} messages."
    },
    "playtime_hours": {
      "title": "Temps de jeu",
      "description_one": "Jouer {{formatted}} heure.",
      "description_other": "Jouer {{formatted}} heures."
    },
    "login_streak": {
      "title": "Série",
      "description_one": "Se connecter {{formatted}} jour d’affilée.",
      "description_other": "Se connecter {{formatted}} jours d’affilée."
    },
    "login_days": {
      "title": "Habitué",
      "description_one": "Se connecter {{formatted}} jour.",
      "description_other": "Se connecter {{formatted}} jours."
    },
    "account_age_days": {
      "title": "Ancienneté",
      "description_one": "Avoir un compte de {{formatted}} jour.",
      "description_other": "Avoir un compte de {{formatted}} jours."
    },
    "quests_completed": {
      "title": "Quêtes",
      "description_one": "Terminer {{formatted}} quête.",
      "description_other": "Terminer {{formatted}} quêtes."
    },
    "player_level": {
      "title": "Niveau",
      "description_one": "Atteindre le niveau {{formatted}}.",
      "description_other": "Atteindre le niveau {{formatted}}."
    }
  },
  "unlocks": {
    "title": {
      "premium_supporter": "Gardien d’ANIDEX",
      "senita_ascended": "Senita",
      "collector": "Collectionneur",
      "living_encyclopedia": "Encyclopédie vivante",
      "mythic_ten": "Panthéon mythique",
      "master_smith": "Maître forgeron",
      "booster_abyss": "Abysse de boosters",
      "merchant": "Marchand",
      "deal_maker": "Maître des échanges",
      "elite": "Élite",
      "social_hub": "Carrefour social",
      "page_turner": "Tourneur de pages",
      "lore_keeper": "Gardien des récits",
      "myth_weaver": "Tisseur de mythes",
      "star_archivist": "Archiviste des étoiles",
      "gold_tongue": "Langue d’or",
      "vault_baron": "Baron du coffre",
      "auction_ghost": "Fantôme des enchères",
      "pact_binder": "Lieur de pactes",
      "anima_alchemist": "Alchimiste d’Anima",
      "ember_hand": "Main de braise",
      "shard_saint": "Saint des éclats",
      "awakening_bell": "Cloche de l’éveil",
      "forge_hymn": "Hymne de la forge",
      "pack_storm": "Tempête de pochettes",
      "pity_breaker": "Briseur de pitié",
      "lucky_fool": "Fou chanceux",
      "divine_touch": "Doigt du destin",
      "week_sentinel": "Sentinelle de la semaine",
      "dawn_regular": "Habitué de l’aube",
      "century_soul": "Âme du siècle",
      "streak_comet": "Comète fidèle",
      "friend_beacon": "Phare des amis",
      "salon_host": "Hôte du salon",
      "whisper_net": "Filet de murmures",
      "reaction_heart": "Cœur réactif",
      "neon_idol": "Idole néon",
      "glitch_prince": "Prince du glitch",
      "sumi_poet": "Poète à l’encre",
      "pixel_hero": "Héros pixel",
      "frost_monarch": "Monarque du givre",
      "gothic_relic": "Relique gothique",
      "terminal_root": "Racine du terminal",
      "stained_saint": "Saint du vitrail",
      "stamp_official": "Tampon officiel",
      "manga_lead": "Rôle principal",
      "aurora_name": "Nom d’aurore"
    },
    "badge": {
      "archive_keeper": "Gardien des archives",
      "legendary_ten": "Cour des légendes",
      "insolent_luck": "Chance insolente",
      "first_divine": "Toucher divin",
      "spent_forge": "Forge ardente",
      "booster_storm": "Tornade de cartes",
      "echo_chamber": "Chambre d’échos",
      "market_mogul": "Collectionneur du marché",
      "quest_veteran": "Vétéran des quêtes",
      "streak_thirty": "Mois fidèle",
      "album_sprout": "Pousse d’album",
      "series_lantern": "Lanterne des séries",
      "rare_spark": "Étincelle rare",
      "shard_chip": "Éclat brut",
      "first_polish": "Premier poli",
      "curious_eye": "Œil curieux",
      "deja_vu_mark": "Marque du déjà-vu",
      "stall_bell": "Cloche de l’étal",
      "handshake": "Poignée scellée",
      "novice_ribbon": "Ruban novice",
      "hex_dice": "Dé hexagonal",
      "fox_mask": "Masque kitsune",
      "torii_gate": "Torii",
      "hourglass": "Sablier",
      "anchor": "Ancre",
      "comet": "Comète",
      "vial": "Fiole",
      "sword_shield": "Épée et bouclier",
      "moon_rabbit": "Lapin de lune",
      "koi": "Koï",
      "cherry_seal": "Sceau de cerisier",
      "oni_fang": "Croc d’oni",
      "shuriken": "Shuriken",
      "fan": "Éventail",
      "lantern": "Lanterne",
      "drum": "Tambour",
      "wave_crest": "Crête de vague",
      "crane": "Grue",
      "dragon_scale": "Écaille de dragon",
      "phoenix": "Phénix",
      "ink_stamp": "Tampon d’encre",
      "vinyl": "Vinyle",
      "cassette": "Cassette",
      "pixel_coin": "Pièce pixel",
      "neon_bolt": "Éclair néon",
      "frost_flake": "Flocon",
      "ember_coal": "Braise",
      "vine": "Liane",
      "gear": "Engrenage",
      "crown_chip": "Éclat de couronne"
    },
    "frame": {
      "premium_orbit": "Orbite dorée",
      "senita_nebula": "N?buleuse Senita",
      "crystal": "Cadre cristallin",
      "awakened": "Cadre éveillé",
      "gold_filigree": "Filigrane d’or",
      "shimenawa": "Shimenawa",
      "thorns": "Ronces",
      "chains": "Chaînes",
      "rune_ring": "Cercle runique",
      "dragon_scale": "Écailles",
      "gears": "Engrenages",
      "nacre": "Nacre divine",
      "laurel": "Laurier",
      "barbed": "Fil barbelé",
      "halo_ring": "Anneau de halo",
      "pixel_bezel": "Cadre pixel",
      "neon_tube": "Tube néon",
      "ink_brush": "Coup de pinceau",
      "frost_rim": "Liseré de givre",
      "flame_rim": "Liseré de flamme",
      "gothic_arch": "Arc gothique",
      "circuit": "Circuit",
      "stained": "Vitrail",
      "stamp_edge": "Bord de tampon",
      "manga_panel": "Case manga",
      "aurora_ring": "Anneau d’aurore",
      "obsidian": "Obsidienne",
      "sakura": "Pétales",
      "chainmail": "Cotte de mailles",
      "compass": "Rose des vents",
      "eclipse": "Éclipse",
      "void_ring": "Anneau du vide"
    },
    "avatar": {
      "premium_stardust": "Éclats d’étoile",
      "explorer": "Boussole d’explorateur",
      "petals": "Pétales",
      "frost": "Givre",
      "neko_ears": "Oreilles de neko",
      "horns": "Cornes",
      "halo": "Halo",
      "wings": "Ailes",
      "scanlines": "Balayage CRT",
      "glitch": "Glitch",
      "kitsune": "Kitsune",
      "summoning": "Cercle d’invocation",
      "hud_reticle": "Viseur",
      "sparkles": "Étincelles",
      "rain": "Pluie",
      "embers": "Braises",
      "bubbles": "Bulles",
      "vines": "Lianes",
      "static": "Neige analogique",
      "moonlight": "Clair de lune",
      "sunglasses": "Lunettes",
      "blush": "Rougissement",
      "demon_eyes": "Regard démoniaque",
      "angel_feathers": "Plumes",
      "pirate": "Pirate",
      "crown": "Couronne",
      "headphones": "Casque",
      "mask_oni": "Masque oni",
      "butterflies": "Papillons",
      "constellation": "Constellation",
      "binary": "Pluie binaire"
    },
    "banner": {
      "premium_constellation": "Constellation dorée",
      "senita_cosmos": "Cosmos Senita",
      "omnibus": "Omnibus",
      "divine_trio": "Triade céleste",
      "trade_baron": "Baron du commerce",
      "summit": "Sommet",
      "team_spirit": "Esprit d’équipe",
      "aurora": "Aurore boréale",
      "neon_rain": "Pluie néon",
      "great_wave": "Grande vague",
      "speed_lines": "Lignes de vitesse",
      "halftone": "Trame",
      "code_rain": "Pluie de code",
      "sky_lanterns": "Lanterne céleste",
      "nebula": "Nébuleuse",
      "sakura_storm": "Tempête de cerisiers",
      "embers_fall": "Chute de braises",
      "snow": "Neige",
      "lightning": "Éclairs",
      "film_grain": "Grain de pellicule",
      "vhs": "VHS",
      "gold_dust": "Poussière d’or",
      "ink_wash": "Lavis d’encre",
      "constellation": "Constellation",
      "grid": "Grille",
      "spotlight": "Projecteur",
      "confetti": "Confettis",
      "fireflies": "Lucioles",
      "ocean": "Océan",
      "ashen": "Cendres",
      "prism": "Prisme",
      "shrine_night": "Nuit de sanctuaire"
    }
  }
}
